// Path: apps/blend-food/src/app/factories/app-config.factory.ts
import { AppConfig } from '@cardapio-online/config';
import { TenantResolverService } from '@cardapio-online/tenant';
import { environment } from '../../environments/environment';

export function appConfigFactory(
  tenantResolver: TenantResolverService
): AppConfig {
  const tenant = tenantResolver.resolve();
  const resolvedTenantSlug =
    tenant.tenantSlug && tenant.tenantSlug !== 'default'
      ? tenant.tenantSlug
      : 'blend-food';
  return {
    appName: 'Blend Food',
    brandPrimary: '#F47D06',
    brandLogoUrl: '/assets/public/blend-food.png',
    mascoteLogo: '/assets/public/sininho-bag.png',
    heroBannerUrl: '/assets/public/hero-banner.jpg',

    /**
     * Fonte real da identidade visual.
     * O BrandKernelService consome essa rota usando HttpClient normal,
     * então interceptors de baseUrl/auth/tenant continuam funcionando.
     */
    brandKernelApiUrl: '/company',
    brandRealtimeEnabled: false,

    environmentName: environment.name,
    apiBaseUrl: environment.apiBaseUrl,
    tenantSlug: resolvedTenantSlug,
    authStorageKey: `${environment.authStorageKey}.${tenant.tenantSlug}`,
  };
}